export default {
  setSkillList (state, payload) {
    state.skills = payload
  }
}
